import { Box, Divider, Grid, Paper, Stack, SxProps } from '@mui/material';
import Author from '../../../Author';
import Optional from '../../../../Optional';
import Img from 'next/image';
import { CardItemType } from '../../type';
import RichText from '../../../../RichText';
import Wrapper from './Wrapper';
import PublishedDate from './PublishedDate';

type Props = CardItemType & {
  sx?: SxProps;
  imageSx?: SxProps;
  isMobile?: boolean;
};

const HorizontalCard = ({
  title,
  description,
  author,
  publishedAt,
  sx,
  imageSx,
  image,
  flip,
  isMobile,
  link,
}: Props) => {
  const shouldFlip = {
    mobile: ['all', 'mobile'].includes(flip!),
    desktop: ['all', 'desktop'].includes(flip!),
  };
  return (
    <Wrapper link={link}>
      <Paper
        elevation={0}
        sx={{ p: 4, borderRadius: { md: 1, xs: 0.5 }, ...sx }}
      >
        <Grid
          container
          spacing={{ xs: 2, md: 4 }}
          direction={{
            xs: shouldFlip.mobile ? 'row-reverse' : 'row',
            md: shouldFlip.desktop ? 'row-reverse' : 'row',
          }}
        >
          <Grid size={{ xs: 12, md: 'grow' }}>
            <Stack
              spacing={2}
              sx={{
                height: '100%',
                width: '100%',
                justifyContent: 'space-between',
              }}
              component={'hgroup'}
            >
              <PublishedDate publishedAt={publishedAt} />
              <RichText withTypography variant={'subtitle1'} component={'h3'}>
                {title}
              </RichText>
              <Box sx={{ color: 'textSecondary' }}>
                <RichText>{description}</RichText>
              </Box>
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, md: 5 }}>
            <Stack
              spacing={3}
              sx={{
                alignItems: {
                  xs: 'start',
                  lg: 'end',
                },
                justifyContent: shouldFlip.desktop ? 'start' : 'end',
                height: '100%',
                width: '100%',
              }}
              direction={{
                xs: 'column',
                md: 'column-reverse',
                lg: shouldFlip.desktop ? 'row-reverse' : 'row',
              }}
            >
              <Divider
                flexItem
                orientation={isMobile ? 'horizontal' : 'vertical'}
                variant={'middle'}
              />
              <Author
                hideAvatar
                author={author}
                variant={
                  isMobile || shouldFlip.desktop ? 'standard' : 'toRight'
                }
              />
              <Optional condition={!!image?.url}>
                <Box
                  sx={{
                    borderRadius: 0.5,
                    position: 'relative',
                    width: '100%',
                    maxWidth: {
                      xs: '100%',
                      md: '400px',
                    },
                    maxHeight: '400px',
                    aspectRatio: image?.meta?.aspectRatio,
                    ...imageSx,
                  }}
                >
                  <Img
                    src={image?.url || ''}
                    alt={image?.altText || 'Image'}
                    fill
                    style={{
                      borderRadius: 'inherit',
                      objectFit: 'cover',
                    }}
                  />
                </Box>
              </Optional>
            </Stack>
          </Grid>
        </Grid>
      </Paper>
    </Wrapper>
  );
};

export default HorizontalCard;
